import React from 'react';

import {IndividualIntegrationPage} from 'shells/integrations/individual-integration-page/individual-integration-page';
import {IntegrationsFormSuccess} from 'shells/integrations/integrations-form/integrations-form-success';
import {INTEGRATIONS_DATA} from 'shells/integrations/integrations-page-content/integrations-data';

import {useIntegrationFormSubmit} from '../../graphql/hooks/use-integration-form-submit';

type Props = {
    integrationId: string;
};

export function IndividualIntegrationPageWrapper(props: Props) {
    const {integrationFormSubmit} = useIntegrationFormSubmit();
    const [successState, setSuccessState] = React.useState<boolean>(false);

    const integration = INTEGRATIONS_DATA.find(
        (item) => item.integrationId === props.integrationId
    );

    // @ts-expect-error
    const submitIntegrationsForm = (integrationId, email, username, password, requestedActions) => {
        integrationFormSubmit({
            integrationId,
            email,
            username,
            password,
            requestedActions,
        }).then(() => {
            setSuccessState(true);
        });
    };

    if (integration) {
        return successState ? (
            <IntegrationsFormSuccess />
        ) : (
            <IndividualIntegrationPage
                // @ts-expect-error
                integration={integration}
                integrationId={props.integrationId}
                submitIntegrationsForm={submitIntegrationsForm}
            />
        );
    }

    return null;
}
